import helper from "../helper";
// import user from "../store/modules/user";

let getSurveyUrl = helper.getSurveyUrlWithParameters

export default {
    getSurveyUrl,
    getByRecievedUrlData:
      /**
       * Получает URL на основе полученных данных
       * @param {Object} url - Объект с данными URL
       * @param {Object} gets - Query-параметры
       * @returns {string} Сформированный URL
       */
      (url, gets = null) => getSurveyUrl(
        url.basename,
        url.action,
        url.params,
        gets
    ),
    WATCHER: {
        FILE: {
            UNLODING:
              /**
               * Получает URL для проверки необходимости выгрузки файлов опроса
               * @param {number} id - Идентификатор опроса
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для проверки необходимости выгрузки
               */
                (id, gets = null) => getSurveyUrl(
                    'surveys|watch_survey|survey-need-unloading',
                    "need_unloading",
                    {id: id},
                    gets
                ),
        },
        SURVEY: {
            LIST:
              /**
               * Получает URL для списка опросов
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для получения списка опросов
               */
                (gets = null) => getSurveyUrl(
                    'surveys|watch_survey|survey-list',
                    "list",
                    gets
                ),
            DETAIL:
              /**
               * Получает URL для детальной информации об опросе
               * @param {number} id - Идентификатор опроса
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для получения деталей опроса
               */
                (id, gets = null) => getSurveyUrl(
                    'surveys|watch_survey|survey-detail',
                    "retrieve",
                    {id: id},
                    gets
                ),
            EXCEL:
              /**
               * Получает URL для выгрузки результатов опроса в Excel
               * @param {number} id - Идентификатор опроса
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для выгрузки Excel
               */
                (id, gets = null) => getSurveyUrl(
                    'surveys|watch_survey|survey-get-exl',
                    "get_exl",
                    {id: id},
                    gets
                ),
        },
        STAGE: {
            LIST:
              /**
               * Получает URL для списка этапов опроса
               * @param {number} survey_id - Идентификатор опроса
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для получения списка этапов
               */
                (survey_id, gets = null) => getSurveyUrl(
                    'surveys|watch_survey|stage-list',
                    "list",
                    {survey_id: survey_id},
                    gets
                ),
            DETAIL:
              /**
               * Получает URL для детальной информации об этапе опроса
               * @param {number} survey_id - Идентификатор опроса
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для получения деталей этапа
               */
                (survey_id, gets = null) => getSurveyUrl(
                    'surveys|watch_survey|stage-list',
                    "retrive",
                    {survey_id: survey_id},
                    gets
                ),
        },
        STAGE_FIELDS: {
            LIST:
              /**
               * Получает URL для списка полей этапа опроса
               * @param {number} survey_id - Идентификатор опроса
               * @param {number} stage_id - Идентификатор этапа
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для получения полей этапа
               */
                (survey_id, stage_id, gets = null) => getSurveyUrl(
                    'surveys|watch_survey|stage_field-list',
                    "list",
                    {
                        survey_id: survey_id,
                        stage_id: stage_id
                    },
                    gets
                ),
        },
        ATTEMPT: {
            LIST:
              /**
               * Получает URL для списка попыток прохождения
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для получения списка попыток
               */
                (gets = null) => getSurveyUrl(
                    'attempts|watch_attempt|attempt-list',
                    "list",
                    gets
                ),
            DETAIL:
              /**
               * Получает URL для детальной информации о попытке прохождения
               * @param {number} id - Идентификатор попытки
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для получения деталей попытки
               */
                (id, gets = null) => getSurveyUrl(
                    'attempts|watch_attempt|attempt-detail',
                    "retrieve",
                    {id: id},
                    gets
                ),
            STAGES:
              /**
               * Получает URL для списка этапов попытки
               * @param {number} attempt_id - Идентификатор попытки
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для получения этапов попытки
               */
              (attempt_id, gets = null) => getSurveyUrl(
                'attempts|watch_attempt|stage-list',
                "list",
                {attempt_id: attempt_id},
                gets
              ),
            FIELDS:
              /**
               * Получает URL для полей этапа попытки
               * @param {number} attempt_id - Идентификатор попытки
               * @param {number} stage_id - Идентификатор этапа
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для получения полей этапа
               */
              (attempt_id, stage_id, gets = null) => getSurveyUrl(
                'attempts|watch_attempt|stage_field-list',
                "list",
                {
                    attempt_id: attempt_id,
                    stage_id: stage_id
                },
                gets
              ),
        },

        STATISTIC: {
            EXCEL:
              /**
               * Получает URL для выгрузки статистики в Excel
               * @param {number} id - Идентификатор опроса
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для выгрузки статистики в Excel
               */
                (id, gets = null) => getSurveyUrl(
                    'surveys|watch_survey|survey-get-exl',
                    "get_exl",
                    {id: id},
                    gets
                ),
        }
    },
}
